<div
  class="flex flex-col gap-y-2 justify-start items-stretch"
  [formGroup]="form"
>
  <div
    class="flex md:flex-row flex-col w-full justify-start items-stretch md:items-start space-y-2 md:space-y-0 md:space-x-4"
  >
    <div
      class="flex flex-col justify-start items-stretch md:w-1/2 w-full space-y-2"
    >
      <mat-form-field class="w-full">
        <mat-label>Template Name</mat-label>
        <input
          matInput
          placeholder="Template Name"
          formControlName="name"
          required
        />
        <mat-error *ngIf="form.get('name').hasError('required')"
          >Template Name is required
        </mat-error>
      </mat-form-field>
      <mat-form-field class="w-full">
        <mat-label>Job Type</mat-label>
        <mat-select formControlName="type" required>
          <mat-option *ngFor="let type of jobTypes" [value]="type">
            {{ type }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('type').hasError('required')"
          >Job Type is required
        </mat-error>
        <mat-hint>The type of the workshop job that will be created.</mat-hint>
      </mat-form-field>
      <mat-form-field class="w-full">
        <mat-label>Job Details</mat-label>
        <textarea
          matInput
          formControlName="details"
          cdkTextareaAutosize="true"
        ></textarea>
        <mat-hint
          >Details of the job, such as the defect or the work to be done.
        </mat-hint>
      </mat-form-field>
      <mat-form-field class="w-full">
        <mat-label>Job Noes</mat-label>
        <textarea
          matInput
          formControlName="notes"
          cdkTextareaAutosize="true"
        ></textarea>
        <mat-hint>Any other notes to be recorded about the job.</mat-hint>
      </mat-form-field>
    </div>
    <div
      class="flex flex-col justify-start items-stretch md:w-1/2 w-full space-y-2"
    >
      <mat-form-field>
        <mat-label>Labour Hours</mat-label>
        <input matInput type="number" formControlName="labour_hours" required />
        <mat-error *ngIf="form.get('labour_hours').hasError('required')"
          >Labour Hours is required
        </mat-error>
        <mat-hint
          >The number of labour hours required to complete the job.
        </mat-hint>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Labour Cost</mat-label>
        <span matPrefix appAddCurrencyPrefix></span>
        <input matInput type="number" formControlName="labour_cost" required />
        <mat-error *ngIf="form.get('labour_cost').hasError('required')">
          Labour Cost is required
        </mat-error>
        <mat-hint>The amount to be charged for labour.</mat-hint>
      </mat-form-field>
    </div>
  </div>

  <h3>Parts List</h3>
  <app-parts-list formControlName="parts"></app-parts-list>
</div>
